import type { FaireProductEntity } from "../../entity_types/product";

export const p_z6h795qseq: FaireProductEntity = {
  token: "p_z6h795qseq",
  type: "product",
  name: "Citron - 8 oz",
  brandToken: "b_64vt8d44",
  brandName: "Le Feu De L'eau",
  imageUrl: "https://cdn.faire.com/fastly/eee20d5021078aa0f2509278dac6f502585fc9448f8c141e4cc1214f0ee6305a.png",
  galleryImageUrls: [],
  priceDollars: 16,
  description: "Our 8 oz candles offer the same high-quality scents you love in a minimalist design, reducing waste and keeping costs down. Each candle is wrapped in paper for a simple, sustainable, and affordable presentation.\n\nProduct Notes:\n• Cruelty-free\n• Coconut apricot wax\n• Natural fragrance / Lead-free cotton wicks\n• No phthalates, parabens, sulfates, ethanol, mineral oils, petroleum distillates, or preservatives\n• Poured in small batches in Los Angeles\n• Our most minimal candle with reduced packaging, wrapped in paper.\n\nBurn Time: 40+ hrs\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:51.121Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
